import {
  GET_ADMINS_SWITCHABLE_ACCS_FAIL,
  GET_ADMINS_SWITCHABLE_ACCS_SUCCESS,
  GET_ADMINS_LIST_FAIL,
  GET_ADMINS_LIST_SUCCESS,
  SWITCH_ADMIN_ACCOUNT_SUCCESS,
  SWITCH_ADMIN_ACCOUNT_FAIL,
  REMOVE_SWITCH_ADMIN_ACCOUNT_SUCCESS,
  REMOVE_SWITCH_ADMIN_ACCOUNT_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  error: [],
  switchAccs: [],
};

const Admins = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REMOVE_SWITCH_ADMIN_ACCOUNT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case REMOVE_SWITCH_ADMIN_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_ADMINS_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };

    case GET_ADMINS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_ADMINS_SWITCHABLE_ACCS_SUCCESS:
      return {
        ...state,
        switchAccs: action.payload,
      };

    case GET_ADMINS_SWITCHABLE_ACCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case SWITCH_ADMIN_ACCOUNT_SUCCESS:
      return {
        ...state,
        switchAccs: action.payload,
      };

    case SWITCH_ADMIN_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Admins;
